import helpers from '../helpers';

/**
* Модуль "Плавный переход к якорю"
*/

const offset = $('.header').height();

function scroll(e) {
	e.preventDefault();
	e.stopPropagation();

	const id = e.target.getAttribute('href');
	const speed = $(e.currentTarget).data('speed') || 500;
	const target = $(id);

	// console.log(offset);
	// console.log('scroll');

	if (helpers.isMobile()) {
		$('html, body').animate({scrollTop: target.offset().top - offset * 1.3}, speed);
	} else {
		$('html, body').animate({scrollTop: target.offset().top - offset}, speed);
	}
}

const init = () => {
	helpers.$document.on('click.anchor', '.js-to-anchor', (e) => {
		scroll(e);
	});
};

const destroy = () => {
	helpers.$document.off('.anchor');
};

export default {
	init,
	destroy,
	scroll,
};
